import React from 'react';
import { FadeIn } from './FadeIn';
import { ScrollTextIcon } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 bg-parchment relative" data-id="element-165">
      <div className="container mx-auto px-4" data-id="element-166">
        <div className="max-w-4xl mx-auto" data-id="element-167">
          <FadeIn data-id="element-168">
            <div className="text-center mb-12" data-id="element-169">
              <span className="text-gold-dark font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-170">
                El Mecanismo Único
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-ink mb-6" data-id="element-171">
                Presentamos el <span className="text-navy" data-id="element-172">Protocolo 2:2</span>
              </h2>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-173">
            <div className="relative bg-white p-8 md:p-12 rounded-sm shadow-xl border border-gold/20 mb-12" data-id="element-174">
              {/* Decorative corners */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-gold rounded-tl-sm" data-id="element-175"></div>
              <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-gold rounded-tr-sm" data-id="element-176"></div>
              <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-gold rounded-bl-sm" data-id="element-177"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-gold rounded-br-sm" data-id="element-178"></div>

              <div className="flex flex-col items-center text-center" data-id="element-179">
                <ScrollTextIcon className="w-12 h-12 text-gold mb-6" strokeWidth={1.5} data-id="element-180" />
                <p className="text-xl md:text-2xl text-charcoal mb-4" data-id="element-181">
                  Basado en la instrucción profética de Habacuc:
                </p>
                <blockquote className="text-2xl md:text-3xl font-serif italic text-navy mb-8 font-bold" data-id="element-182">
                  "Escribe la visión, y declárala en tablas"
                </blockquote>

                <div className="w-24 h-[1px] bg-gold/50 mb-8" data-id="element-183"></div>

                <p className="text-lg text-charcoal leading-relaxed max-w-2xl" data-id="element-184">
                  No es solo leer la Biblia, es convertirla en un{' '}
                  <strong className="text-ink" data-id="element-185">contrato legal</strong>. Este
                  método te enseña a codificar tus necesidades en decretos de
                  autoridad que eliminan el "ruido" mental y alinean tu espíritu
                  con el flujo de suministro divino que nunca se agota.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}